import { render } from "./BillingInfo.vue?vue&type=template&id=17fea7bc&scoped=true&bindings={\"billingAddress\":\"props\",\"small\":\"props\"}"
import script from "./BillingInfo.vue?vue&type=script&lang=js"
export * from "./BillingInfo.vue?vue&type=script&lang=js"

import "./BillingInfo.vue?vue&type=style&index=0&id=17fea7bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17fea7bc"

export default script